"use strict";

var _defineProperty = require("/mnt/ephemeral/jenkins/workspace/chart-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("../../../theme/styled"));

var emotion_theming_1 = require("emotion-theming");

var NavbarBrand = styled_1["default"].div(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    display: 'inline-block',
    margin: 'auto 0',
    '& > img': {
      maxHeight: theme.navbar.logoHeight,
      maxWidth: '100%'
    }
  }, "@media (max-width: ".concat(theme.navbar.collapseAt, ")"), {
    padding: 0
  });
});
exports["default"] = emotion_theming_1.withTheme(NavbarBrand);